import hosts from 'hosts.json'

/**
 * Derive API/auth host from app hostname. Used for redirects and API base URL.
 * Mirrors staging logic: app.stagingN.payhelm.com -> client.stagingN.payhelm.com
 */
export function getApiHost(hostname: string): string {
  if (hosts.apiHost[hostname]) {
    return hosts.apiHost[hostname]
  }
  if (hostname === '127.0.0.1' || hostname === '0.0.0.0') {
    return hosts.apiHost.localhost
  }
  const stagingMatch = hostname.match(/^app\.(staging\d*)\.payhelm\.com$/)
  if (stagingMatch) {
    return `https://client.${stagingMatch[1]}.payhelm.com`
  }
  return hosts.apiHost['app.payhelm.com']
}

/**
 * Derive notification/backfill ingest host from app hostname.
 * API Store orders and spec downloads use node-email, not the Papaya API host.
 */
export function getNotificationHost(hostname: string): string {
  if (hosts.apiNotificationHost[hostname]) {
    return hosts.apiNotificationHost[hostname]
  }
  const stagingMatch = hostname.match(/^app\.(staging\d*)\.payhelm\.com$/)
  if (stagingMatch) {
    const env = stagingMatch[1]
    if (env === 'staging') {
      return 'https://notifications.payhelm.com'
    }
    if (env === 'staging2') {
      return 'https://notifications.staging.payhelm.com'
    }
    return `https://notifications.${env}.payhelm.com`
  }
  return hosts.apiNotificationHost['app.payhelm.com']
}
